import { createStore, createLogger } from "vuex";
import qrcode from "./modules/qrcode";
import record from "./modules/record";
import auth from "./modules/auth";
import rgpd from "./modules/rgpd";
import { QrcodeState } from "./modules/qrcode/state";
import { RecordState } from "./modules/record/state";
import { AuthState } from "./modules/auth/state";
import { RGPDState } from "./modules/rgpd/state";

const debug = process.env.NODE_ENV !== "production";

export interface State {
    qrcode: QrcodeState;
    record: RecordState;
    auth: AuthState;
    rgpd: RGPDState;
}

const store = createStore<State>({
    modules: {
        qrcode,
        record,
        auth,
        rgpd
    },
    strict: debug,
    plugins: debug ? [createLogger()] : []
});

export default store;
